var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"sfdocs__footer"},[_c('p',{staticClass:"align-text-vertically domain"},[_vm._v(_vm._s(_vm.domain))]),_c('p',{staticClass:"align-text-vertically credit"},[_vm._v("Made by Sunstreet IT")])])}
var staticRenderFns = []

export { render, staticRenderFns }